/**
 * @desc: 供应商 供应商列表查询
 * @create：2020/4/21
 * @author: yeungxsheng
 * @version: v1.0
 */

import {
  fetchSupplierList,
  fetchDetails,
  fetchSupplierPosBySupId,
  updatePosAndSim,
  unfreeze,
  freeze,
  transferSupplierOwnership,
  listSupplierOwnership,
  getSupApplyInfo,
  getSupLookContract,
  againSupContract
} from '@/api/T2/supplierCheck'

export default {
  namespaced: true,
  state: {
    serviceList: '',
    checkoutList: []
  },
  getters: {
    checkoutListData: state => state.checkoutList
  },
  mutations: {
    setServiceList: (state, payload) => {
      state.serviceList = payload
    },
    setDetails: (state, payload) => {
      state.setDetails = payload
    },
    setCheckoutList: (state, data) => {
      state.checkoutList = data;
    }
  },
  actions: {
    // 供应商查询--列表接口
    getSupplierList({ commit }, payload) {
      return fetchSupplierList(payload).then(res => {
        if (res && res.status === 200) {
          commit('setServiceList', res.data)
          return res
        }
      })
    },

    // 供应商查询 - 查看
    getDetails({ commit }, payload) {
      return fetchDetails(payload).then(res => {
        if (res && res.status === 200) {
          commit('setDetails', res.data)
          return res.data
        } else {
          return {}
        }
      })
    },
    // 获取供应商终端
    getSupplierPos(ctx, payload) {
      return fetchSupplierPosBySupId(payload).then(res => {
        return res
      })
    },
    // 修改详情里的终端信息 -array
    updatePos(ctx, payload) {
      return updatePosAndSim(payload).then(res => {
        return res
      })
    },

    // 冻结供应商
    freeze(ctx, payload) {
      return freeze(payload).then(res => {
        return res
      })
    },

    // 解冻供应商
    unfreeze(ctx, payload) {
      return unfreeze(payload).then(res => {
        return res
      })
    },

    // 转移归属
    transferSupplierOwnership(ctx, payload) {
      return transferSupplierOwnership(payload).then(res => {
        return res
      })
    },

    //获取归属信息
    listSupplierOwnership(ctx, payload) {
      return listSupplierOwnership(payload).then(res => {
        return res
      })
    },

    // 审批信息 getSupApplyInfo
    getSupApplyInfo(ctx, payload) {
      return getSupApplyInfo(payload).then(res => {
        return res
      })
    },
    // 合同
    getSupLookContract(ctx, payload) {
      return getSupLookContract(payload).then(res => {
        return res
      })
    },

    // 供应商-签章
    againSupContract(ctx, payload) {
      return againSupContract(payload).then(res => {
        return res
      })
    },
  }
}
